export const THUMB_STYLE = {
  height: "15px",
  width: "15px",
  borderRadius: "2px",
  backgroundColor: "#FFF",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  boxShadow: "0px 2px 2px #AAA",
};

export const OTLOOK_THUMB_STYLE = {
  border: "2px solid #666666",
  borderRadius: "4px",
  height: "16px",
  width: "8px",
  backgroundColor: "#FFF",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const TRACK_STYLE = {
  height: "5px",
  width: "100%",
  borderRadius: "3px",
  alignSelf: "center",
};
